const Data = [
  {
    "id": 1,
    "heading": "Aquatics Center",
    "sports": "Water Polo, Artistic Swimming, Diving",
    "copy": "Copy about this stadium",
    "image": "Aquatics-Center-Diving.jpg",
    "location": "paris"
  },
  { 
    "id": 2,
    "heading": "Champ-de-Mars Arena",
    "sports": "Judo, Wrestling",
    "copy": "Copy about this stadium",
    "image": "Arena-Champ-de-Mars-judo.jpg",
    "location": "paris"
  },
  {
    "id": 3,
    "heading": "Bercy Arena",
    "sports": "Gymnastics (Artistic), Gymnastics (Trampoline), Basketball (Finals)",
    "copy": "Copy about this stadium",
    "image": "Bercy-Arena-Basketball.jpg",
    "location": "paris"
  },
  {
    "id": 4,
    "heading": "Chateau de Versailles",
    "sports": "Equestrian (Jumping, Dressage, Eventing), Modern Pentathlon",
    "copy": "Copy about this stadium",
    "image": "Chteau-de-Versailles.jpg",
    "location": "paris"
  },
  {
    "id": 5,
    "heading": "Eiffel Tower Stadium",
    "sports": "Beach Volleyball",
    "copy": "Copy about this stadium",
    "image": "Eiffel-Tower-Stadium.jpg",
    "location": "paris"
  },
  {
    "id": 6,
    "heading": "Geoffroy Guichard Stadium",
    "sports": "Football",
    "copy": "Copy about this stadium",
    "image": "Geoffroy-Guichard-Stadium.jpg",
    "location": "france"
  },
  {
    "id": 7,
    "heading": "Golf National",
    "sports": "Golf",
    "copy": "Copy about this stadium",
    "image": "Golf-National.jpg",
    "location": "paris"
  },
  {
    "id": 8,
    "heading": "Grand Palais",
    "sports": "Fencing, Taekwondo",
    "copy": "Copy about this stadium",
    "image": "Grand-Palais.jpg",
    "location": "paris"
  },
  {
    "id": 9,
    "heading": "Invalides",
    "sports": "Cycling (Individual Time Trial - Start), Archery, Athletics (Marathon - Finish)",
    "copy": "Copy about this stadium",
    "image": "Invalides.jpg",
    "location": "paris"
  },
  {
    "id": 10,
    "heading": "La Beaujoire Stadium",
    "sports": "Football",
    "copy": "Copy about this stadium",
    "image": "La-Beaujoire-Stadium.jpg",
    "location": "france"
  },
  {
    "id": 11,
    "heading": "Lyon Stadium",
    "sports": "Football",
    "copy": "Copy about this stadium",
    "image": "Lyon-Stadium.jpg",
    "location": "france"
  },
  {
    "id": 12,
    "heading": "Marina de Marseille",
    "sports": "Sailing",
    "copy": "Copy about this stadium",
    "image": "Marina-de-Marseille.jpg",
    "location": "france"
  },
  {
    "id": 13,
    "heading": "Nice Stadium",
    "sports": "Football",
    "copy": "Copy about this stadium",
    "image": "Nice-Stadium.jpg",
    "location": "france"
  },
  {
    "id": 14,
    "heading": "Olympic Village",
    "sports": "Olympic Village",
    "copy": "Copy about this stadium",
    "image": "Olympic-Village.jpg",
    "location": "paris"
  },
  {
    "id": 15,
    "heading": "Opening Ceremony",
    "sports": "Opening Ceremony",
    "copy": "Copy about this stadium",
    "image": "Opening-Ceremony-Visual.jpg",
    "location": "paris"
  },
  {
    "id": 16,
    "heading": "Parc des Princes, Paris",
    "sports": "Football",
    "copy": "Copy about this stadium",
    "image": "Parc-des-Princes-Football.jpg",
    "location": "paris"
  },
  {
    "id": 17,
    "heading": "Paris La Defense Arena",
    "sports": "Aquatics (Swimming, Water-Polo - Finals)",
    "copy": "Copy about this stadium",
    "image": "Paris-La-Defense-Arena.jpg",
    "location": "paris"
  },
  {
    "id": 18,
    "heading": "Pierre Mauroy Stadium",
    "sports": "Basketball (Preliminaries), Handball (Finals)",
    "copy": "Copy about this stadium",
    "image": "Pierre-Mauroy-Stadium.jpg",
    "location": "france"
  },
  {
    "id": 19,
    "heading": "Porte de la Chapelle Arena",
    "sports": "Badminton, Gymnastics (Rythmic)",
    "copy": "Copy about this stadium",
    "image": "Porte-de-la-Chapelle-Arena.jpg",
    "location": "paris"
  },
  {
    "id": 20,
    "heading": "Arc de Triomphe",
    "sports": "Logo",
    "copy": "Copy about this stadium",
    "image": "Presentation-of-the-logo-on-the-Arc-de-Triomphe.jpg",
    "location": "paris"
  },
  {
    "id": 21,
    "heading": "Paris 2024 on the Eiffel Tower",
    "sports": "",
    "copy": "Copy about this stadium",
    "image": "Revelation-Paris-2024-on-the-Eiffel-Tower.jpg",
    "location": "paris"
  },
  {
    "id": 22,
    "heading": "Roland Garros Stadium",
    "sports": "Tennis, Boxing (Finals)",
    "copy": "Copy about this stadium",
    "image": "Roland-Garros-Stadium.jpg",
    "location": "paris"
  },
  {
    "id": 23,
    "heading": "Saint Quentin en Yvelines BMX Stadium",
    "sports": "Cycling (BMX Racing)",
    "copy": "Copy about this stadium",
    "image": "Saint-Quentin-en-Yvelines-BMX-Stadium.jpg",
    "location": "paris"
  },
  {
    "id": 24,
    "heading": "Saint Quentin en Yvelines Velodrome",
    "sports": "Cycling (Track)",
    "copy": "Copy about this stadium",
    "image": "Saint-Quentin-en-Yvelines-Velodrome.jpg",
    "location": "paris"
  },
  {
    "id": 25,
    "heading": "South Paris Arena",
    "sports": "",
    "copy": "Copy about this stadium",
    "image": "South-Paris-Arena.jpg",
    "location": "paris"
  },
  {
    "id": 26,
    "heading": "Stade de France",
    "sports": "Rugby, Athletics",
    "copy": "Copy about this stadium",
    "image": "Stade-de-France.jpg",
    "location": "paris"
  },
  {
    "id": 27,
    "heading": "Teahupoo, Tahiti",
    "sports": "Surfing",
    "copy": "Copy about this stadium",
    "image": "Teahupoo-Tahiti.jpg",
    "location": "os"
  },
  {
    "id": 28,
    "heading": "Yves du Manoir Stadium",
    "sports": "Hockey",
    "copy": "Copy about this stadium",
    "image": "Yves-du-Manoir-Stadium.jpg",
    "location": "paris"
  }
 ]

export default Data


// WEBPACK FOOTER //
// ./src/components/Data.js